const roundToCents = (number: number): number => parseFloat(number.toFixed(2))
export default roundToCents
